import { render, staticRenderFns } from "./PageDailyGame.vue?vue&type=template&id=7ed9e54f&"
import script from "./PageDailyGame.vue?vue&type=script&lang=js&"
export * from "./PageDailyGame.vue?vue&type=script&lang=js&"
import style0 from "./PageDailyGame.vue?vue&type=style&index=0&id=7ed9e54f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports